import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import slick from "slick-carousel";
import PerfectScrollbar from "perfect-scrollbar";

/* ==============================================
ヘッダーの部分
============================================== */
// export function servicesFunc() {
//   let servicesTop = $("#servicesTop").length;

//   if (servicesTop) {
//     // subNavHeightFunc();

//     subNavAccordionFuc();

//     subNavScrollFunc();

//     // function subNavHeightFunc() {
//     //   let subNavHeight = $(".subNav");
//     //   let headerHeight = $("#header").outerHeight();
//     //   subNavHeight.css("top", `${headerHeight}px`);

//     //   let setTimer = false;
//     //   $(window).on("resize", function () {
//     //     if (setTimer !== false) {
//     //       clearTimeout(setTimer);
//     //     }
//     //     setTimer = setTimeout(() => {
//     //       subNavHeightFunc();
//     //     }, 200);
//     //   });
//     // }

//     function subNavAccordionFuc() {
//       const servicesSubNavAccordionBtn = $("#servicesSubNav .accordionBtn");
//       const servicesSubNav = $("#servicesSubNavList a");
//       let resizecheck = $("#responsibleCheck").width();
//       let resizecheck2 = 0;

//       $(window).on("load resize", function () {
//         resizecheck = $("#responsibleCheck").width();
//         subNavAccordionMenuStart();
//         subNavCloseFunc();
//       });

//       //スマホのみサブナビをクリックでクローズさせる
//       function subNavCloseFunc() {
//         if (resizecheck == "2") {
//           servicesSubNav.on("click", subNavClickHandler);
//         } else if (resizecheck == "1") {
//           servicesSubNav.off("click", subNavClickHandler);
//         }
//       }
//       function subNavClickHandler() {
//         servicesSubNavAccordionBtn.next("dd").slideUp(500);
//         $("#servicesSubNav").removeClass("isNavOpen");
//         servicesSubNavAccordionBtn.removeClass("isOpen");
//       }
//       subNavCloseFunc();

//       servicesSubNavAccordionBtn.on("click", function () {
//         const subNav = $("#servicesSubNav");

//         if (resizecheck == "2") {
//           if ($(this).hasClass("isOpen")) {
//             $(this)
//               .next("dd")
//               .slideUp(500, function () {
//                 subNav.removeClass("isNavOpen");
//               });
//             $(this).removeClass("isOpen");
//           } else {
//             servicesSubNavAccordionBtn.next("dd").slideUp(500);
//             servicesSubNavAccordionBtn.removeClass("isOpen");
//             $(this).next("dd").slideDown(500);
//             $(this).addClass("isOpen");

//             subNav.addClass("isNavOpen");
//           }
//         }
//       });

//       var subNavAccordionMenuStart = function () {
//         let resizecheck = $("#responsibleCheck").width();
//         if (resizecheck == "2" && resizecheck != resizecheck2) {
//           servicesSubNavAccordionBtn.next("dd").css("display", "none");
//           resizecheck2 = 2;
//         } else if (resizecheck == "1" && resizecheck != resizecheck2) {
//           servicesSubNavAccordionBtn.removeClass("isOpen");
//           servicesSubNavAccordionBtn.next("dd").css("display", "block");
//           resizecheck2 = 1;
//         }
//       };
//       subNavAccordionMenuStart();
//     }

//     function subNavScrollFunc() {
//       // 今回の交差を監視する要素
//       const boxes = document.querySelectorAll(".servicesList .list");

//       const options = {
//         root: null,
//         rootMargin: "0% 0px -87%",
//         threshold: 0,
//       };
//       const observer = new IntersectionObserver(doWhenIntersect, options);
//       boxes.forEach((box) => {
//         observer.observe(box);
//       });

//       /**
//        * 交差したときに呼び出す関数
//        * @param entries
//        */
//       function doWhenIntersect(entries) {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             activateIndex(entry.target);
//           }
//         });
//       }
//       /**
//        * 目次を変える関数
//        * @param element
//        */
//       function activateIndex(element) {
//         const currentActiveIndex = document.querySelector("#servicesSubNavList .active");
//         if (currentActiveIndex !== null) {
//           currentActiveIndex.classList.remove("active");
//         }
//         const newActiveIndex = document.querySelector(`a[href='#${element.id}']`).parentElement;
//         newActiveIndex.classList.add("active");

//         const currentTxt = document.querySelector(`a[href='#${element.id}']`).textContent;
//         $("#navCurrent").text(currentTxt).css({ color: "#fff" });
//       }
//     }

//     $(window).on("load scroll", function () {
//       var subNavCurrent = $("#servicesSubNavList .pageLinkList");
//       var scroll = $(window).scrollTop();
//       if (scroll == 0) {
//         $("#navCurrent").text("TENGA 20th Anniversary").css({ color: "#fff" });
//         if (subNavCurrent.hasClass("active")) {
//           subNavCurrent.removeClass("active");
//         }
//       }
//     });
//   }
// }

export function animation() {
  gsap.registerPlugin(ScrollTrigger);

  let mm = gsap.matchMedia();

  // 共通のタイムライン設定
  mm.add("(min-width: 768px)", () => {
    // --- PC用の順番 ---
    let tl = gsap.timeline();

    // バギー
    tl.fromTo(".fvProduct.buggy, .fvItem.buggy", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });
    tl.fromTo(".fvLine1", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

        // ティーチ
    tl.fromTo(".fvProduct.teach, .fvItem.teach", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });
    tl.fromTo(".fvLine3", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

    
    // シャンクス
    tl.fromTo(".fvProduct.shanks, .fvItem.shanks", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });
    tl.fromTo(".fvLine2", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });


    // ルフィ
    tl.fromTo(".fvProduct.luffy, .fvItem.luffy", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

    tl.fromTo(".fvLogo1, .fvLogo2, .fvTxt", { autoAlpha: 0 }, { autoAlpha: 1, ease: "power1.inOut" }, "<1");
  });

  mm.add("(max-width: 767px)", () => {
    // --- SP用の順番 (ティーチとシャンクスを逆転) ---
    let tl = gsap.timeline();

    // バギー
    tl.fromTo(".fvProduct.buggy, .fvItem.buggy", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

    // SP：ティーチを先に
    tl.fromTo(".fvProduct.teach, .fvItem.teach", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

    tl.fromTo(".fvLine1", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

    // SP：シャンクスを後に
    tl.fromTo(".fvProduct.shanks, .fvItem.shanks", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

    tl.fromTo(".fvLine2", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

    // ルフィ
    tl.fromTo(".fvProduct.luffy, .fvItem.luffy", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3 });

    tl.fromTo(".fvLogo1, .fvLogo2, .fvTxt", { autoAlpha: 0 }, { autoAlpha: 1, ease: "power1.inOut" }, "<1");
  });

  // --- .fadeIn の処理は共通なので外に置く ---
// --- .fadeIn の処理 ---
  gsap.utils.toArray(".fadeIn").forEach((target) => {
    gsap.fromTo(
      target,
      { autoAlpha: 0 },
      {
        autoAlpha: 1,
        scrollTrigger: {
          trigger: target,
          scroller: ".scroll",
          start: "top 70%",
        },
      },
    );
  });
}

export function slide() {
  // 追従ボタン
const scrollContainer = document.querySelector(".scroll");

scrollContainer.addEventListener("scroll", function () {
  const trigger = document.getElementById("js-floating-start");
  const triggerEnd = document.getElementById("js-floating-end");
  const fixContent = document.getElementById("fixedBtnWrap");

  if (!trigger || !triggerEnd || !fixContent) return;

  const startPos = trigger.getBoundingClientRect().top;
  const endPos = triggerEnd.getBoundingClientRect().top;

  const vh = window.innerHeight;
  const isStarted = startPos < 0; 
  const isNotReachedEnd = endPos > vh;

  if (isStarted && isNotReachedEnd) {
    fixContent.classList.add("is-show");
  } else {
    fixContent.classList.remove("is-show");
  }
});
}
export function scrollBar() {
  window.addEventListener("load", function () {
    const targets = document.querySelectorAll(".detailMainItemLineScrollWrapSp.buggy,.detailMainItemLineScrollWrapSp.teach");
    const initScrollbar = () => {
      const isSP = window.innerWidth <= 767;

      targets.forEach((target) => {
        if (isSP) {
          // SP（767以下）のとき → PerfectScrollbar 有効化
          if (!target._ps) {
            target._ps = new PerfectScrollbar(target, {
              suppressScrollY: true, // 縦スクロール無効化
            });

            target.addEventListener("click", function () {
              target.classList.add("isActive");
              target._ps.update();
            });
          }
        } else {
          // PC（768以上）のとき → PerfectScrollbar 無効化
          if (target._ps) {
            target._ps.destroy();
            target._ps = null;
          }
        }
      });
    };

    // 初期化
    initScrollbar();

    // リサイズ対応
    window.addEventListener("resize", initScrollbar);
  });
}
